import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_RET017_Request,
  IAPI_RET017_Response,
  IAPI_RET018_Request,
  IAPI_RET018_Response,
} from "../../../type/apiType";

// 受領者変更参照API
const httpAPI_RET017 = async (
  param: IAPI_RET017_Request
): Promise<IAPI_RET017_Response> => {
  let res = await http.post(ApiUrl.API_RET017, {
    ...param,
  });
  return res.data;
};

// 受領者変更更新API
const httpAPI_RET018 = async (
  param: IAPI_RET018_Request
): Promise<IAPI_RET018_Response> => {
  let res = await http.post(ApiUrl.API_RET018, {
    ...param,
  });
  return res.data;
};

export { httpAPI_RET018, httpAPI_RET017 };
